import { render, staticRenderFns } from "./EsclarecimentoImpugnacaoFiltro.vue?vue&type=template&id=0c13b278"
import script from "./EsclarecimentoImpugnacaoFiltro.vue?vue&type=script&lang=js"
export * from "./EsclarecimentoImpugnacaoFiltro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports